import { render, staticRenderFns } from "./Instructors.vue?vue&type=template&id=107625e2&scoped=true"
import script from "./Instructors.vue?vue&type=script&lang=js"
export * from "./Instructors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107625e2",
  null
  
)

export default component.exports